import { setLoadingConfigObject } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './AddOnsUsersLoading.styles';

const headerLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, {
      ...styles.lineStyle(160, 16),
      ...styles.marginStyle(0, 24),
    }),
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.lineStyle(160, 16)),
    right: setLoadingConfigObject('square', 1, '10%', styles.lineStyle(64, 12)),
    style: styles.marginStyle(0, 29),
  },
];
const titleLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.lineStyle(174, 24)),
  },
];
const userLoadingConfig = [
  {
    left: setLoadingConfigObject('circle', 1, 50, styles.circleStyle),
    main: setLoadingConfigObject('line', 1, '100%', styles.lineStyle(245, 15.36)),
  },
  {
    main: setLoadingConfigObject('line', 1, '100%', {
      ...styles.divider,
      ...styles.marginStyle(14, 13),
    }),
  },
];
const NoAssignedUsersLoadingConfig = [
  headerLoadingConfig[0],
  {
    left: setLoadingConfigObject('circle', 1, 50, styles.circleStyle),
    main: [
      'column',
      setLoadingConfigObject('square', 1, null, styles.lineStyle('100%', 12)),
      setLoadingConfigObject('square', 1, null, {
        ...styles.lineStyle('100%', 12),
        ...styles.marginStyle(8, 8),
      }),
      setLoadingConfigObject('square', 1, null, {
        ...styles.lineStyle(80, 12),
      }),
    ],
  },
  {
    main: setLoadingConfigObject('line', 1, '100%', {
      ...styles.divider,
      ...styles.marginStyle(14, 16),
    }),
  },
  headerLoadingConfig[1],
];

const assignedUsersLoadingConfig = [
  headerLoadingConfig[0],
  ...userLoadingConfig,
  ...userLoadingConfig,
  headerLoadingConfig[1],
];

const unAssignedUsersLoadingConfig = [
  ...userLoadingConfig,
  ...userLoadingConfig,
  ...userLoadingConfig,
  ...userLoadingConfig,
  ...userLoadingConfig,
];

const footerLoadingConfig = usersCount => [
  {
    ...(usersCount === 0 && {
      main: setLoadingConfigObject('square', 1, null, styles.squareStyle(40)),
      style: styles.squareContainerStyle,
    }),
  },

  {
    main: setLoadingConfigObject('square', 1, null, {
      ...styles.buttonStyle(usersCount !== 0 ? 15 : 0),
    }),
    style: styles.squareContainerStyle,
  },
];

export {
  titleLoadingConfig,
  NoAssignedUsersLoadingConfig,
  footerLoadingConfig,
  assignedUsersLoadingConfig,
  unAssignedUsersLoadingConfig,
};
